// Barra de rolagem no mesmo estilo do menu lateral (layout/MainListItems.js):
// fina (4px) e visível só quando o mouse está sobre a área rolável.
// Uso dentro de makeStyles: { overflowY: "auto", ...sidebarScrollbar(theme) }
const sidebarScrollbar = (theme) => ({
  "&:hover": {
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.grey[500],
    },
  },
  "&::-webkit-scrollbar": {
    width: "4px",
    height: "4px",
  },
  "&::-webkit-scrollbar-track": {
    background: "transparent",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "transparent",
    borderRadius: "8px",
  },
  "&::-webkit-scrollbar-corner": {
    background: "transparent",
  },
});

export default sidebarScrollbar;
